function getHumanDuration(duration, full) {
	var durationSign = duration < 0 ? '-' : '';
	duration = Math.abs(Math.round(duration));
	var h = Math.floor(duration / 3600),
		m = Math.floor(duration % 3600 / 60),
		s = duration % 3600 % 60,
		r = [];

	(h || parseBool(full)) && r.push(h);
	(h || m || parseBool(full)) && r.push(m < 10 && r.length ? '0' + m : m);
	r.push(s < 10 && r.length ? '0' + s : s);
	return durationSign + r.join(':');
}
function getHumanBandwidth(speed, round) {
	var types = ['б/сек', 'кб/сек', 'мб/сек', 'гб/сек', 'тб/сек'];
	if(typeof locale != 'undefined') {
		types = locale['bandwidths'];
	}

	var type = 0;
	while(speed > 1024) {
		speed /= 1024;
		type++;
	}

	if(round) {
		var fix = Math.pow(10, isNaN(round) ? 0 : round);
		speed = Math.round(speed * fix) / fix;
	} else if(speed < 10) {
		speed = Math.round(speed * 100) / 100;
	} else if(speed < 100) {
		speed = Math.round(speed * 10) / 10;
	} else {
		speed = Math.round(speed);
	}
	return speed + ' ' + types[type];
}
function getHumanFileSize(size, round) {
	var divider = 1000;
	var fix = Math.pow(10, isNaN(round) ? 0 : round);
	var types = ['б', 'Кб', 'Мб', 'Гб', 'Тб', 'Пб', 'Эб', 'Зб', 'Иб'];
	if(typeof locale != 'undefined') {
		types = locale['bandwidths'];
	}

	var type = 0;
	while(size > divider) {
		size /= divider;
		type++;
	}

	size = Math.round(size * fix) / fix;
	return size + ' ' + types[type];
}

function validateEmail(email) {
	var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([а-яёa-z\-0-9]+\.)+[а-яёa-z]{2,}))$/i;
	return re.test(email);
}

function parseBool(v) {
	if(typeof v == 'string' && v.toLowerCase) v = v.toLowerCase();
	return v && v !== '0' && v !== 'false' && v !== 'off' && v !== 'no' && v !== 'null';
}

function parse_url(url) {
	var a = document.createElement('a');
	a.href = url;
	return {
		protocol: a.protocol.replace(':', ''),
		host: a.hostname,
		port: a.port,
		query: a.search,
		params: (function(){
			var ret = {},
				seg = a.search.replace(/^\?/,'').split('&'),
				len = seg.length, i = 0, s;
			for (;i<len;i++) {
				if (!seg[i]) { continue; }
				s = seg[i].split('=');
				ret[s[0]] = s[1];
			}
			return ret;
		})(),
		file: (a.pathname.match(/\/([^\/?#]+)$/i) || [,''])[1],
		hash: a.hash.replace('#',''),
		path: a.pathname.replace(/^([^\/])/,'/$1'),
		relative: (a.href.match(/tp:\/\/[^\/]+(.+)/) || [,''])[1],
		segments: a.pathname.replace(/^\//,'').split('/'),
		getParameter: function(name, defaultValue) {
			name = name.toLowerCase();
			var params = {};
			Object.keys(this.params).forEach(function(key) {
				params[key.toLowerCase()] = this.params[key];
			}.bind(this));
			return typeof params[name] !== 'undefined' ? params[name] : defaultValue;
		}
	};
}

function intval(value) {
	return isNaN(value) ? 0 : parseInt(value);
}

function in_array(value, arr) {
	return arr instanceof Array && arr.indexOf && arr.indexOf(value) >= 0;
}

function is_callable(func) {
	return typeof func == 'function';
}

function createEventListener(object) {
	object = object || {};
	var listeners = {};

	object.on = function(eventName, cb, once, context) {
		if(eventName instanceof Array) {
			eventName.forEach(function(eventName) {
				object.on(eventName, cb, once);
			});
		} else {
			if(!listeners[eventName]) {
				listeners[eventName] = [];
			}
			listeners[eventName].push({
				cb: cb,
				once: parseBool(once),
				context: context
			});
		}
		return object;
	};

	object.once = function(eventName, cb, context) {
		return object.on(eventName, cb, true, context);
	};

	object.trigger = function(eventName, args, context) {
		if(!(args instanceof Array)) {
			args = typeof args != 'undefined' ? [args] : [];
		}
		if(typeof context == 'undefined') {
			context = object;
		}
		if(listeners[eventName]) {
			var onceKey = [];
			listeners[eventName].forEach(function(listener, index) {
				try {
					listener.cb.apply(listener.context || context, args);
				} catch(e) {
					console.error('trigger ', (context && context.constructor && context.constructor.name ? context.constructor.name + ': ' : ' ') + eventName, e.message);
				}
				if(listener.once) {
					onceKey.push(index);
				}
			});
			onceKey.forEach(function(key) {
				delete listeners[eventName][key];
			});
		}
	};
	return object;
}


// Date

if(typeof Date.prototype.format == 'undefined') {
	Date.prototype.format = function(format) {
		var monthNames1 = (window.locale && window.locale["dateFormat.month"]) || ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"];
		var monthNames2 = (window.locale && window.locale["dateFormat.month2"]) || ["Января", "Февраля", "Марта", "Апреля", "Мая", "Июня", "Июля", "Августа", "Сентября", "Октября", "Ноября", "Декабря"];
		var date = '';
		format = format.split('');
		for(var i in format) {
			if(format.hasOwnProperty(i)) {
				switch(format[i]) {
					case 'Y': date += (this.getFullYear() < 10 ? '0' : '') + this.getFullYear(); break;
					case 'm': date += ((this.getMonth()+1) < 10 ? '0' : '') + (this.getMonth()+1); break;
					case 'd': date += (this.getDate() < 10 ? '0' : '') + this.getDate(); break;
					case 'H': date += (this.getHours() < 10 ? '0' : '') + this.getHours(); break;
					case 'i': date += (this.getMinutes() < 10 ? '0' : '') + this.getMinutes(); break;
					case 's': date += (this.getSeconds() < 10 ? '0' : '') + this.getSeconds(); break;
					case 'f': date += monthNames1[this.getMonth()]; break;
					case 'F': date += monthNames2[this.getMonth()]; break;
					default: date += format[i];
				}
			}
		}
		return date;
	}
}

if(typeof Date.prototype.getTimestamp == 'undefined') {
	Date.prototype.getTimestamp = function(in_ms) {
		return !in_ms ? Math.round(this.getTime() / 1000) : this.getTime();
	}
}

if(typeof Date.fromTimestamp == 'undefined') {
	Date.fromTimestamp = function(timestamp, in_ms) {
		return new Date(in_ms ? timestamp : timestamp * 1000);
	}
}

if(typeof Date.fromString == 'undefined') {
	Date.fromString = function(str) {
		var reg = new RegExp('^([0-9]{4})-([0-9]{1,2})-([0-9]{1,2}) ([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})$', '');
		var res = reg.exec(str);
		if(res) {
			return new Date(res[1], res[2] - 1, res[3], res[4], res[5], res[6]);
		}
		return new Date();
	};
}

if(typeof Date.nowTimestamp == 'undefined') {
	Date.nowTimestamp = function() {
		return (new Date).getTimestamp();
	};
}

if(typeof Date.getServerTime == 'undefined') {
	Date.getServerTime = function() {
		var date = new Date;
		date.setTime(date.getTime() + (window.serverTimeDifference || 0) * 1000);
		return date;
	};
}

function date(format, date) {
	if(typeof date == 'undefined') {
		date = format;
		format = null;
	}

	date = date instanceof Date ? date : new Date(parseInt(date) * 1000);

	return format ? date.format(format) : date.toLocaleString();
}

function deepEqual(a, b) {

	if (a === b) return true;

	var arrA = Array.isArray(a)
		, arrB = Array.isArray(b)
		, i
		, length
		, key;

	if (arrA && arrB) {
		length = a.length;
		if (length != b.length) return false;
		for (i = 0; i < length; i++)
			if (!deepEqual(a[i], b[i])) return false;
		return true;
	}

	if (arrA != arrB) return false;

	var dateA = a instanceof Date
		, dateB = b instanceof Date;
	if (dateA != dateB) return false;
	if (dateA && dateB) return a.getTime() == b.getTime();

	var regexpA = a instanceof RegExp
		, regexpB = b instanceof RegExp;
	if (regexpA != regexpB) return false;
	if (regexpA && regexpB) return a.toString() == b.toString();

	if (a instanceof Object && b instanceof Object) {
		var keys = Object.keys(a);
		length = keys.length;

		if (length !== Object.keys(b).length)
			return false;

		for (i = 0; i < length; i++)
			if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

		for (i = 0; i < length; i++) {
			key = keys[i];
			if (!deepEqual(a[key], b[key])) return false;
		}

		return true;
	}

	return false;
}

function isObject(object) {
	return object != null && typeof object === 'object';
}

// /Date
